import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  ResponseErrorWithHandled,
  ResponseSuccess,
} from '../../../../../../shared/types';

import { UpdateMaxSendingLimitPayload, UpdateSendingLimitsPayload } from './types';
import {
  getEspLimits,
  updateInboxPlacementMaxSendingLimit,
  updateMaxSendingLimit,
  updateSendingLimits,
} from '../../../../helpers/email-account-sending-limit';

export const getEspLimitsRequest = createAsyncThunk<
  ResponseSuccess,
  null,
  { rejectValue: ResponseErrorWithHandled }
>('emailAccountSendingLimit/getEspLimits', async (args, thunkAPI) => {
  try {
    return await getEspLimits();
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

export const updateMaxSendingLimitRequest = createAsyncThunk<
  ResponseSuccess,
  UpdateMaxSendingLimitPayload,
  { rejectValue: ResponseErrorWithHandled }
>(
  'emailAccountSendingLimit/updateMaxSendingLimit',
  async ({ emailAccountId, limit }, thunkAPI) => {
    try {
      return await updateMaxSendingLimit({ emailAccountId, limit });
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const updateInboxPlacementMaxSendingLimitRequest = createAsyncThunk<
  ResponseSuccess,
  UpdateMaxSendingLimitPayload,
  { rejectValue: ResponseErrorWithHandled }
>(
  'emailAccountSendingLimit/updateInboxPlacementMaxSendingLimit',
  async ({ emailAccountId, limit }, thunkAPI) => {
    try {
      return await updateInboxPlacementMaxSendingLimit({
        emailAccountId,
        limit,
      });
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const updateSendingLimitsRequest = createAsyncThunk<
  ResponseSuccess,
  UpdateSendingLimitsPayload,
  { rejectValue: ResponseErrorWithHandled }
>(
  'emailAccountSendingLimit/updateSendingLimits',
  async ({ emailAccountId, maxSendingLimit, inboxPlacementDailySendingLimit }, thunkAPI) => {
    try {
      const payload: { maxSendingLimit?: number; inboxPlacementDailySendingLimit?: number } = {};
      if (maxSendingLimit !== undefined) payload.maxSendingLimit = maxSendingLimit;
      if (inboxPlacementDailySendingLimit !== undefined) payload.inboxPlacementDailySendingLimit = inboxPlacementDailySendingLimit;
      return await updateSendingLimits({ emailAccountId, payload });
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);
